import {Injectable} from '@angular/core';
import {ApiService} from '../api/api.service';
import {Observable} from 'rxjs/Rx';
import { Cacheable } from 'ts-cacheable';
import { CACHE_KEYS } from 'src/app/helpers/Cache';

@Injectable({
    providedIn: 'root'
})
export class PointsService {

    constructor(private api: ApiService) {
    }

    public get(params): Observable<any> {
        return this.api.get('/points', {
            params: params
        });
    }

    public history(params): Observable<any> {
        return this.api.get('/points/history', {
            params: params
        });
    }

    public getV2(params?): Observable<any> {
        return this.api.get('/points/v2', { params });
    }

    public historyV2(params?): Observable<any> {
        return this.api.get('/points/v2/history', { params });
    }

    // maxAge 30 minutes
    @Cacheable({ cacheKey: CACHE_KEYS.points, maxAge: 30 * 60 * 1000 })
    public getHeaderPoints(params?): Observable<any> {
        return this.api.get('/points/v2/info', { params })
    }

    public info(): Observable<any> {
      return this.api.get('/points/v2/info', {});
    }
}
